var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/insta_handle_error.2108d55d.png","uri@2x": __webpack_public_path__ + "static/media/insta_handle_error.382d23ee.png","uri@3x": __webpack_public_path__ + "static/media/insta_handle_error.981c6f3d.png",
    width: 16,
    height: 16
});